export const Clear = "Clear";
export const IdentityPickerAlias = "Alias";
export const IdentityPickerContact = "Contact";
export const IdentityPickerContactInfo = "Contact information";
export const IdentityPickerDepartment = "Department";
export const IdentityPickerEmail = "Email";
export const IdentityPickerHeaderButtonLabel = "Go back";
export const IdentityPickerLoadingText = "Loading identities...";
export const IdentityPickerLocation = "Location";
export const IdentityPickerNoResultsText = "No identities found";
export const IdentityPickerOrganization = "Organization";
export const IdentityPickerPhoneNumber = "Phone number";
export const IdentityPickerPlaceholderFocusText = "Assign people";
export const IdentityPickerPlaceholderText = "No one selected";
export const IdentityPickerProfileCardAriaLabel = "Contact card";
export const IdentityPickerProfileCardButtonTooltip = "Show Contact Card";
export const IdentityPickerReportingTo = "Reporting to {0} ({1})";
export const IdentityPickerReportsTo = "Reports to";
export const IdentityPickerResultsFoundText = "Showing {0} results";
export const IdentityPickerStartChat = "Start chat";
export const IdentityPickerTitle = "Title";
export const Loading = "Loading...";
export const MultiIdentityPickerPlaceholderText = "Add people";
export const Remove = "Remove {0}";
export const RemoveFromRecent = "Remove {0} from recent";
export const UnknownUserOrGroup = "Unknown user or group: {0}";
